import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { Subscription } from 'rxjs';
import { TargetedAdService } from './targeted-ad.service';

/**
 * The Targeted Ad Component
 *
 * This component is responsible for creating a targeted ad on the page
 */
@Component({
  selector: 'td-wb-targeted-ad',
  templateUrl: 'targeted-ad.component.html',
  styleUrls: ['targeted-ad.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TargetedAdComponent  implements OnInit, OnDestroy {
  /**
   * The page where the targeted ad is going to be located
   */
  @Input() targetId: string;

  @HostBinding('class.td-wb-targeted-ad--visible') visible: boolean = false;

  /**
   * The subscription to TargetedAdService.onLoad
   */
  private subscription: Subscription;

  /**
   * The constructor of the component
   *
   * @param targetedAdService The service that retrieves the ad details
   */
  constructor(private targetedAdService: TargetedAdService) {
  }

  /**
   * This function is called when the component is initialized
   * and is used to retrieve the ad details from the [Targeted Ad Service]{@link TargetedAdService}
   * by calling [Targeted Ad Service's getTargetedAd method]{@link TargetedAdService#getTargetedAd}
   */
  ngOnInit(): void {
    this.subscription = this.targetedAdService.onLoad.subscribe((value: boolean): void => {
      if (value) {
        this.targetedAdService.getTargetedAd(this.targetId);
        this.visible = value;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription !== undefined) {
      this.subscription.unsubscribe();
    }
  }
}
